"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var mobx_react_1 = require("mobx-react");
var api_1 = __importStar(require("api"));
var config_1 = __importDefault(require("config"));
var use_stores_1 = require("hooks/use-stores");
var help_icon_svg_1 = __importDefault(require("res/img/help-icon.svg"));
var star_icon_svg_1 = __importDefault(require("res/img/star-icon.svg"));
var dayjs_1 = __importDefault(require("dayjs"));
var apiRoutes = config_1.default.apiRoutes;
var EditProductReviews = mobx_react_1.observer(function (_a) {
    var product = _a.product;
    var _b = react_1.useState([]), productReviews = _b[0], setProductReviews = _b[1];
    var params = react_router_dom_1.useParams();
    var apiStore = use_stores_1.useStores().apiStore;
    var busyRoutes = apiStore.data.busyRoutes;
    react_1.useEffect(function () {
        if (!busyRoutes.includes(apiRoutes.PRODUCTS + apiRoutes.PRODUCT_REVIEWS)) {
            api_1.default.getProductReviews(product.id)
                .then(function (response) { return setProductReviews(response.data); })
                .catch(api_1.catchHandler);
        }
    }, [params.id]);
    var createStars = function (productReview) {
        var starArray = [];
        for (var i = 0; i < productReview.rating; i++) {
            starArray.push(react_1.default.createElement("img", { src: star_icon_svg_1.default, alt: 'Rating Star' }));
        }
        return starArray;
    };
    return (react_1.default.createElement("div", { className: 'edit-product__page edit-product-reviews' },
        react_1.default.createElement("span", { className: 'title' }, "Product Reviews"),
        react_1.default.createElement("div", { className: 'help flex flex-row' },
            react_1.default.createElement("img", { src: help_icon_svg_1.default, alt: 'Help' }),
            react_1.default.createElement("p", null, "See reviews for this product. Only customers with verified purchases will be able to leave reviews.")),
        react_1.default.createElement("div", { className: 'edit-product-reviews__list' }, productReviews.map(function (productReview) { return (react_1.default.createElement("div", { className: 'edit-product-reviews__review', key: productReview.id },
            react_1.default.createElement("div", { className: 'edit-product-reviews__review__top flex flex-row flex-space-between' },
                react_1.default.createElement("div", { className: 'edit-product-reviews__review__stars flex flex-row' }, createStars(productReview)),
                react_1.default.createElement("div", { className: 'edit-product-reviews__review__date flex flex-row' },
                    react_1.default.createElement("span", null,
                        "Posted: ",
                        dayjs_1.default(productReview.createdAt).format('DD/MM/YYYY')))),
            productReview.images.length > 0 &&
                react_1.default.createElement("div", { className: 'edit-product-reviews__review_images flex flex-row' }, productReview.images.map(function (image) { return (react_1.default.createElement("div", { className: 'image', key: image.id },
                    react_1.default.createElement("img", { src: image.thumbnail, alt: 'Review Image' }))); })),
            react_1.default.createElement("div", { className: 'edit-product-reviews__review__body' },
                react_1.default.createElement("span", { className: 'title' }, productReview.title),
                react_1.default.createElement("p", null, productReview.description),
                react_1.default.createElement("span", { className: 'author' },
                    "Posted by: ",
                    productReview.author)))); }))));
});
exports.default = EditProductReviews;
